module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "tw-py-2 tw-px-3 tw-shadow-md tw-rounded-full tw-font-semibold tw-text-sm",
    class: {
      'tw-bg-red-400 tw-bg-opacity-10 tw-text-red-700': _vm.isRedColor() && !_vm.disabled,
        'tw-bg-green-400 tw-bg-opacity-10 tw-text-green-700': _vm.isGreenColor() && !_vm.disabled,
        'tw-bg-light-blue-inot tw-bg-opacity-10 tw-text-light-blue-inot': _vm.isBlueColor() && !_vm.disabled,
        'tw-bg-light-orange-inot tw-text-dark-orange-inot': _vm.isOrangeColor() && !_vm.disabled,
        'tw-bg-gray-400 tw-bg-opacity-10 tw-border-gray-400 tw-text-gray-700': _vm.disabled,
    },
    attrs: {
      "title": _vm.title,
      "disabled": _vm.disabled
    }
  }, [(_vm.icon !== '') ? _c('span', {
    class: [_vm.icon + ' fa-fw ', {
      'tw-text-gray-400': _vm.disabled
    }]
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.text) + "\n    ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-715b1154"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Pill/Pill.vue.html
// module id = q5Tm
// module chunks = 2